import { combineReducers } from 'redux';
import entityReducer from './dataSources';
import uiReducer from './ui';
import appReducer from './app';
import authReducer from './auth';

const rootReducer = combineReducers({
  entities: entityReducer,
  ui: uiReducer,
  app: appReducer,
  auth: authReducer,
});

export default rootReducer;
